var _path;

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from "react";

function SvgCommonIconMarker(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 26 25"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.5,
    d: "M12.5 0a8.331 8.331 0 00-8.333 8.333c0 3.807 2.01 7.898 3.987 11.068 1.978 3.17 3.955 5.42 3.955 5.42.1.112.242.177.391.177.149 0 .29-.065.39-.177 0 0 1.98-2.297 3.956-5.485 1.975-3.188 3.987-7.27 3.987-11.003A8.331 8.331 0 0012.5 0zm0 1.042a7.272 7.272 0 017.292 7.291c0 3.351-1.894 7.335-3.825 10.45-1.618 2.61-2.987 4.29-3.467 4.866-.484-.572-1.853-2.215-3.467-4.801-1.929-3.093-3.825-7.082-3.825-10.515A7.272 7.272 0 0112.5 1.042zm0 4.166a3.653 3.653 0 00-3.646 3.646A3.653 3.653 0 0012.5 12.5a3.653 3.653 0 003.646-3.646A3.653 3.653 0 0012.5 5.208zm0 1.042a2.596 2.596 0 012.604 2.604 2.596 2.596 0 01-2.604 2.604 2.596 2.596 0 01-2.604-2.604A2.596 2.596 0 0112.5 6.25z"
  })));
}

export default SvgCommonIconMarker;